import { createTheme } from '@mui/material/styles';

const primaryColor = '#618c03';
const secondaryColor = '#f44336';
const colorWhite = '#fff';
// Mirrors `$text`, `$lightGray` and `$lightBackground` in theme/colors.scss.
const textColor = '#3c3c3f';
const borderColor = '#ced4da';
const hoverBackground = '#f3f7f8';

// Buttons follow the client's X-style brief: fully rounded, bold, no capitals,
// and only two looks — filled green (`contained`) or white (`outlined`).
const theme = createTheme({
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 9999,
          textTransform: 'none',
          fontWeight: 700,
          letterSpacing: 0,
          '&.MuiButton-containedPrimary:hover': {
            backgroundColor: primaryColor,
            opacity: 0.8,
            color: colorWhite
          },
          '&.MuiButton-outlinedPrimary': {
            backgroundColor: colorWhite,
            borderColor,
            color: textColor
          },
          '&.MuiButton-outlinedPrimary:hover': {
            backgroundColor: hoverBackground,
            borderColor,
            color: textColor
          },
          '&.MuiButton-outlinedSecondary:hover': {
            backgroundColor: secondaryColor,
            opacity: 0.8,
            color: colorWhite
          },
          '&.MuiButton-containedSecondary:hover': {
            backgroundColor: secondaryColor,
            opacity: 0.8,
            color: colorWhite
          }
        },
        // A pill needs more room at the ends than MUI's square defaults give it.
        contained: {
          paddingInline: 20,
          '&.MuiButton-sizeSmall': { paddingInline: 14 }
        },
        outlined: {
          paddingInline: 19,
          '&.MuiButton-sizeSmall': { paddingInline: 13 }
        }
      }
    }
  },
  palette: {
    primary: {
      light: '#757ce8',
      main: primaryColor,
      dark: '#535665',
      contrastText: '#fff'
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000'
    }
  }
});

export { theme };
